// global
export const SAVE_ERROR = "SAVE_ERROR"
export const LOADING_START = "LOADING_START"
export const LOADING_END = "LOADING_END"
// related to modules
export const SAVE_REFERRALS = "SAVE_REFERRALS"
export const SAVE_REFERRAL = "SAVE_REFERRAL"
export const PUSH_TO_REFERRALS = "PUSH_TO_REFERRALS"

